import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../components/presentation/Text'

import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation('listMasks')

  return (
    <>
      <Separator weight={12} />
      <Grid justify="space-between" gutter={0.4}>
        <Col>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t(`title`)}
          </Title>
        </Col>

        <Col flex={1}></Col>
      </Grid>

      <Separator weight={2} />
    </>
  )
}

export default PageHeader
